import { configSSO } from '../../assets/js/config.js'
import auth0 from 'auth0-js'
import Cookie from 'js-cookie'

export default class T2Auth {
  /**
   * @type T2Auth
   */
  static instance = null

  /**
   * @returns T2Auth
   */
  static getInstance () {
    if (this.instance === null) {
      this.instance = new T2Auth()
    }
    return this.instance
  }

  constructor () {
    this.accessToken = Cookie.get(configSSO.ACCESS_TOKEN_NAME)
    this.initWebAuth()
    this.refreshingTokenInProgress = false
    this.logginInProgress = false
  }

  /**
   * Login uporabnika
   */
  login () {
    if (this.logginInProgress === false) {
      this.logginInProgress = true
      this.webAuth.baseOptions.redirectUri = this.getCurrentLocationWithoutHashtag()
      this.deleteAuth0Cookies()
      this.webAuth.authorize()
    }
  }

  /**
   * Logout uporabnika
   */
  logout (redirectUri) {
    let baseOptions = this.webAuth.baseOptions
    let logoutUrl = 'https://' + configSSO.AUTH0_DOMAIN + '/logout?'
    logoutUrl += 'redirect_uri=' + (redirectUri || this.getCurrentLocationWithoutHashtag())
    logoutUrl += '&client_id=' + baseOptions.clientID
    logoutUrl += '&response_type=' + baseOptions.responseType
    logoutUrl += '&scope=' + baseOptions.scope
    this.deleteTokens()
    window.location = logoutUrl
  }

  /**
   * Po backendu pridobimo nov token
   */
  refreshToken () {
    if (this.refreshingTokenInProgress !== true) {
      this.refreshingTokenInProgress = true
      this.webAuth.baseOptions.redirectUri = window.location.protocol + '//' + window.location.host + '/RenewToken'
      this.webAuth.checkSession({}, function (err, authResult) {
        T2Auth.getInstance().refreshingTokenInProgress = false
        if (err) {
          console.error(err)
        }
      })
      /* potreba timeouta, ker v primeru uspešnega klica checkSession ne naredi callbacka */
      setTimeout(() => {
        this.refreshingTokenInProgress = false
      }, 2000)
    }
  }

  /**
   * Inicializacija auth0
   */
  initWebAuth () {
    let options = {
      domain: configSSO.AUTH0_DOMAIN,
      clientID: configSSO.AUTH0_CLIENT_ID,
      redirectUri: this.getCurrentLocationWithoutHashtag(),
      responseType: configSSO.AUTH0_RESPONSE_TYPE,
      scope: configSSO.AUTH0_SCOPE,
      leeway: 60
    }
    this.webAuth = new auth0.WebAuth(options)
  }

  /**
   * Vrnemo trenutno lokacijo brez hashtagov
   */
  getCurrentLocationWithoutHashtag () {
    let redirectUri = location.href
    if (redirectUri.indexOf('#') > 0) {
      redirectUri = redirectUri.substring(0, redirectUri.indexOf('#'))
    }
    return redirectUri
  }

  /**
   * @param vmesnik
   */
  checkTokens (vmesnik) {
    let t2AuthRef = this
    if ((typeof this.accessToken) !== 'undefined') {
      if (typeof window.parent.t2AuthRef !== 'undefined' && window.parent.t2AuthRef.accessToken !== this.accessToken) {
        window.parent.t2AuthRef.accessToken = this.accessToken
        window.parent.t2AuthRef.checkTokens(configSSO.ACCESS_TOKEN_NAME)
      }
    } else {
      t2AuthRef.deleteTokens()
    }
  }

  /**
   * Ali obstaja access token
   * @returns {boolean}
   */
  isAccessTokenSet () {
    if ((typeof this.accessToken) !== 'undefined') {
      return true
    }
    return false
  }

  /**
   * Settange tokenov
   * @param authResult
   */
  setTokens (authResult) {
    if (authResult.accessToken !== null) {
      var now = new Date()
      var time = now.getTime()
      var expireTime = time + (1000 * authResult.expiresIn)
      Cookie.set(configSSO.ACCESS_TOKEN_NAME, authResult.accessToken)
      Cookie.set(configSSO.ACCESS_TOKEN_EXPIRES_AT, expireTime)
      this.accessToken = authResult.accessToken
    }
  }
  /**
   * brisanje cookijev, ki se zacnejo z 'com.auth0.auth.'
   */
  deleteAuth0Cookies () {
    let pairs = document.cookie.split(';')
    for (let i = 0; i < pairs.length; i++) {
      let pair = pairs[i].split('=')
      if ((pair[0] + '').trim().substring(0, 'com.auth0.auth.'.length) === 'com.auth0.auth.') {
        Cookie.remove(pair[0])
      }
    }
  }

  /**
   * Brisanje žetonov
   */
  deleteTokens () {
    let t2AuthRef = this
    Cookie.remove(configSSO.ACCESS_TOKEN_NAME)
    Cookie.remove(configSSO.ACCESS_TOKEN_EXPIRES_AT)
    Cookie.remove('zacasnaNarocnina')
    this.deleteAuth0Cookies()
    t2AuthRef.login()
  }

  /**
   * Preverba ali cookie obstaja
   * @param vmesnik
   */
  handleAuthentication (vmesnik) {
    let t2AuthRef = this
    this.webAuth.parseHash(function (err, authResult) {
      window.location.hash = ''
      if (authResult) {
        t2AuthRef.setTokens(authResult)
        t2AuthRef.deleteAuth0Cookies()
      } else if (err) {
        console.error(err)
      }
    })
    t2AuthRef.checkTokens(vmesnik)
  }

  /**
   * Prikaz gumbov
   */
  displayLogoutButtons () {
    this.logoutBtn.style.display = 'inline-block'
  }

  /**
   * inicializacija grafičnih elementov
   */
  initGUI () {
    this.ignorirajGumbe = false
    this.userpicture = document.getElementById('t2userpicture')
    this.userpicture2 = document.getElementById('t2userpicture2')
    this.logoutBtn = document.getElementById('t2logoutbtn')
    let t2AuthRef = this
    this.logoutBtn.addEventListener('click', function (e) {
      e.preventDefault()
      t2AuthRef.logout()
    })
  }

  /**
   * Prikaz logout gumbov
   */
  displayLoginButtons () {
    this.logoutBtn.style.display = 'none'
    this.userpicture.style.display = 'none'
    this.userpicture2.style.display = 'none'
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/t2Auth.js